import { useField } from 'formik'
import { useTranslation } from 'react-i18next'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import CardContent from '@mui/material/CardContent'
import { CardHeader, Typography } from '@mui/material'
import LicensePlate from '@cbgms/components/form/LicensePlate'
import { IVehicle } from '@cbgms/api'
import React, { useMemo } from 'react'

interface Props {}
export const VehicleCard: React.FC<Props> = () => {
  const { t } = useTranslation()
  const [{ value: registration }] = useField<string | undefined>('Registration')
  const [{ value: country }] = useField<string | undefined>('Country')
  const [{ value: vin }] = useField<string | undefined>('Vin')
  const [{ value: vehicle }] = useField<Partial<IVehicle>>('vehicle')

  const firstRowSize = 4
  const enteredRegistration = useMemo(() => `${country}|${registration}`, [country, registration])

  return (
    <Card variant='outlined'>
      <CardHeader title={t('vehicle.technical_info')} sx={{ pb: 0 }} />
      <CardContent>
        <Grid container direction='column' spacing={0.2}>
          <Grid item container direction='row' spacing={1}>
            <Grid item xs={firstRowSize}>
              <Typography>{t('vehicle.brand')}:</Typography>
            </Grid>
            <Grid item xs='auto'>
              <TechInfoTypography>{vehicle?.Manufacturer}</TechInfoTypography>
            </Grid>
          </Grid>
          <Grid item container direction='row' spacing={1}>
            <Grid item xs={firstRowSize}>
              <Typography>{t('vehicle.construction_year_range')}:</Typography>
            </Grid>
            <Grid item xs='auto'>
              <TechInfoTypography>{vehicle?.ConstructionYear}</TechInfoTypography>
            </Grid>
          </Grid>
          <Grid item container direction='row' spacing={1}>
            <Grid item xs={firstRowSize}>
              <Typography>{t('vehicle.model')}:</Typography>
            </Grid>
            <Grid item xs='auto'>
              <TechInfoTypography>{vehicle?.Model}</TechInfoTypography>
            </Grid>
          </Grid>
          <Grid item container direction='row' spacing={1}>
            <Grid item xs={firstRowSize}>
              <Typography>{t('vehicle.type')}:</Typography>
            </Grid>
            <Grid item xs={8}>
              <TechInfoTypography>{vehicle?.Type}</TechInfoTypography>
            </Grid>
            <Grid item container direction='row' spacing={1}>
              <Grid item xs={firstRowSize}>
                <Typography>{t('vehicle.registration')}:</Typography>
              </Grid>
              <Grid item xs='auto'>
                <LicensePlate registration={enteredRegistration} data-testid='vehicle-information-registration' size='small' />
              </Grid>
            </Grid>
          </Grid>
          <Grid item container direction='row' spacing={1}>
            <Grid item xs={firstRowSize}>
              <Typography>{t('vehicle.vin')}:</Typography>
            </Grid>
            <Grid item xs={8}>
              <TechInfoTypography>{vin}</TechInfoTypography>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

function TechInfoTypography({ children }: React.PropsWithChildren<{}>) {
  return <Typography sx={{ wordBreak: 'break-all' }}>{children || '-'}</Typography>
}
